<template>
    <v-card ref="fsRoot" id="projection" elevation="0" :class="{ 'fullscreen-mode': isFullscreen }" class="projection">
      <v-card-text class="projection__body">
        <v-row align="center" no-gutters class="mb-2 projection__topbar">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="extenderPantalla">
            <v-icon left>{{ fsIcon }}</v-icon>
            {{ fsLabel }}
          </v-btn>
        </v-row>
        <v-tabs-items v-model="tab" class="projection__tabs">
          <!-- inicio de los que son solo pa nyx o glm --> 
          <!-- <v-tab-item 
            value="tab-1"
          >
            <ReporteIncidenciasMensual
              :update="tiempoActualizacion"
            >
            </ReporteIncidenciasMensual>
          </v-tab-item> -->
          <v-tab-item value="tab-1" class="projection__tab-item">
            <ReporteEficienciaOperadoresCarrusel
              v-if="nombreEmpresa === 'TAMTO'"
              :update="tiempoActualizacion"
            />
            <ReporteIncidenciasTurno
              v-else
              :update="tiempoActualizacion"
            />
          </v-tab-item>
          <v-tab-item value="tab-2" class="projection__tab-item">
            <ReporteOEEFechasCarrusel
              v-if="nombreEmpresa === 'TAMTO'"
              :update="tiempoActualizacion"
            />
            <OeesCriticos
              v-else
              :update="tiempoActualizacion"
            />
          </v-tab-item>
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-3"
            eager
          >
            <ReporteOEETurno
              :update="tiempoActualizacion"
              ref="reporteoeeturno"
            >
            </ReporteOEETurno>
          </v-tab-item>
          <!-- <v-tab-item 
            value="tab-5"
            eager
          >
            <ReporteOEEMensual
              :update="tiempoActualizacion"
              ref="reporteoeemensual"
            >
            </ReporteOEEMensual>
          </v-tab-item> -->
          <!-- <v-tab-item
            value="tab-6"
          >
            <OEEDesglosadoDiaAnterior
              :update="tiempoActualizacion"
            >
            </OEEDesglosadoDiaAnterior>   
          </v-tab-item>

          <v-tab-item
            value="tab-7"
          >
            <ReporteMTTRMTBFMensual
              :update="tiempoActualizacion"
            >
            </ReporteMTTRMTBFMensual>   
          </v-tab-item> -->

          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-4"
          >
            <ReporteMTTRMTBFTurno
              :update="tiempoActualizacion"
            >
            </ReporteMTTRMTBFTurno>   
          </v-tab-item>
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-5"
          >
            <ReporteTiemposParos
              :update="tiempoActualizacion"
              ref="reportetiemposparos"
            >
            </ReporteTiemposParos>   
          </v-tab-item>
          <!-- <v-tab-item
            value="tab-6"
          >
            <TiempoParosMensual
              :update="tiempoActualizacion"
            >
            </TiempoParosMensual>   
          </v-tab-item> -->
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-6"
          >
            <TiempoParosTurno
              :update="tiempoActualizacion"
            >
            </TiempoParosTurno>   
          </v-tab-item>
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-7"
          >
            <v-card flat>
              <v-card-text v-card-text class="pa-0" style="height: 100vh; overflow: hidden;">
                <iframe
                  width="100%"
                  height="100%"
                  title="Análisis de Defectos"
                  :src="powerDefectos"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-8"
          >
            <v-card flat>
              <v-card-text v-card-text class="pa-0" style="height: 100vh; overflow: hidden;">
                <iframe
                  width="100%"
                  height="100%"
                  title="Pareto de Tiempos de Paro por Causa y Subcausa"
                  :src="powerParos"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="nombreEmpresa != 'TAMTO'"
            value="tab-9"
          >
            <v-card flat>
              <v-card-text v-card-text class="pa-0" style="height: 100vh; overflow: hidden;">
                <iframe
                  width="100%"
                  height="100%"
                  title="Pareto de Tiempos de Paros por Máquina"
                  :src="powerParosMaquinas"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  
</template>

<script>
import ReportePiezasTerminadas from "./Proyeccion/ReportePiezasTerminadas.vue"
import ReporteRendimientoOperador from "./Proyeccion/ReporteRendimientoOperador.vue"
import ReporteAvanceTiempoEntrega from "./Proyeccion/ReporteAvanceTiempoEntrega.vue"
import Matriz3 from '../Dashboards/Matriz3.vue'
import ReporteIncidenciasMensual from "./Proyeccion/ReporteIncidenciasMensual.vue"
import ReporteMTTRMTBFMensual from "./Proyeccion/ReporteMTTRMTBFMensual.vue"
import ReporteMTTRMTBFTurno from "./Proyeccion/ReporteMTTRMTBFTurno.vue"
import ReporteOEETurno from "./Proyeccion/ReporteOEETurno.vue"
import ReporteOEEMensual from "./Proyeccion/ReporteOEEMensual.vue"
import ReporteIncidenciasTurno from "./Proyeccion/ReporteIncidenciasTurno.vue"
import MotivosParosNivelesVue from "./Proyeccion/MotivosParosNiveles.vue";
import OeesCriticos from "./Proyeccion/OeesCriticos.vue";
import TiempoParosMensual from "./Proyeccion/TiempoParosMensual.vue";
import TiempoParosTurno from "./Proyeccion/TiempoParosTurno.vue";
import ReporteTiemposParos from "./Proyeccion/ReporteTiemposParos.vue";
import OEEDesglosadoDiaAnterior from "./Proyeccion/OEEDesglosadoDiaAnterior.vue"
import ReporteEficienciaOperadoresCarrusel from "./Proyeccion/ReporteEficienciaOperadoresCarrusel.vue"
import ReporteOEEFechasCarrusel from "./Proyeccion/ReporteOEEFechasCarrusel.vue"
import { mapState } from "vuex";



export default {
  components:{
    ReportePiezasTerminadas,
    ReporteRendimientoOperador,
    ReporteAvanceTiempoEntrega,
    Matriz3,
    ReporteIncidenciasMensual,
    ReporteMTTRMTBFMensual,
    ReporteOEETurno,
    ReporteOEEMensual,
    ReporteIncidenciasTurno,
    ReporteMTTRMTBFTurno,
    MotivosParosNivelesVue,
    OeesCriticos,
    TiempoParosMensual,
    TiempoParosTurno,
    ReporteTiemposParos,
    OEEDesglosadoDiaAnterior,
    ReporteEficienciaOperadoresCarrusel,
    ReporteOEEFechasCarrusel
  },
  props:{
    value:{
      type: Boolean,
      default: false,
    }
  },
  watch: {
    pos(){
      if(this.pos == 2){
        if(typeof this.$refs.piezasterminadas === 'undefined') return;
        this.$refs.piezasterminadas.initialize();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // tus initialize()...
      if (this.$refs.oeescriticos) {
        this.$refs.oeescriticos.fechaPorDefecto?.();
        this.$refs.oeescriticos.initialize?.();
      }
      if (this.$refs.reporteoeeturno) {
        this.$refs.reporteoeeturno.fechaPorDefecto?.();
        this.$refs.reporteoeeturno.initialize?.();
      }
      if (this.$refs.reportetiemposparos) {
        this.$refs.reportetiemposparos.fechaPorDefecto?.();
        this.$refs.reportetiemposparos.initialize?.();
      }
    });

    this.interval = setInterval(() => {
      this.pos = (this.pos === 2) ? 1 : (this.pos + 1);
    }, 62 * 1000);

    const sync = () => {
      this.isFullscreen = !!(document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement);
    };

    document.addEventListener('fullscreenchange', sync);
    document.addEventListener('webkitfullscreenchange', sync);
    document.addEventListener('MSFullscreenChange', sync);
    this._syncFs = sync;
  },

  beforeDestroy() {
    clearInterval(this.interval);

    if (this._syncFs) {
      document.removeEventListener('fullscreenchange', this._syncFs);
      document.removeEventListener('webkitfullscreenchange', this._syncFs);
      document.removeEventListener('MSFullscreenChange', this._syncFs);
    }
  },
  computed:{
		...mapState({
			nombreEmpresa: "nombreEmpresa"
		}),
    powerDefectos() {  //analísis de defectos
      if (this.nombreEmpresa === 'Cazel') {
        return 'https://app.powerbi.com/view?r=https://app.powerbi.com/view?r=eyJrIjoiNGMyMjQ1OWMtOGMzYi00YzkxLTk2YTEtNGM0N2YxYmFlYzljIiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else if (this.nombreEmpresa === 'CAZEL-TLT') {
        return 'https://app.powerbi.com/view?r=eyJrIjoiNTIyOWM1NDMtOWE5Zi00NzhlLTlkOGYtMWVjMzdlOGU4ZjZjIiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else {
        return ''; 
      }
    },
     powerParos() {  //pareto de tiempos por causa y subcausa
      if (this.nombreEmpresa === 'Cazel') {
        return 'https://app.powerbi.com/view?r=eyJrIjoiNGI4ZjI3MWMtZWJiZS00OTkzLWFhZTgtMmEwOWJkNDZjODVhIiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else if (this.nombreEmpresa === 'CAZEL-TLT') {
        return 'https://app.powerbi.com/view?r=eyJrIjoiNWFlNWIxOWMtNTE1Yi00ZDk5LTkxODctMWQxMTJiNzEwZDkzIiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else {
        return ''; 
      }
    },
     powerParosMaquinas() {  //pareto de tiempos por máquina
      if (this.nombreEmpresa === 'Cazel') {
        return 'https://app.powerbi.com/view?r=eyJrIjoiMWMyOWVlNzQtNTBiYi00N2FiLWI5ZTMtYjk4ZTYwNzcwNTAxIiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else if (this.nombreEmpresa === 'CAZEL-TLT') {
        return 'https://app.powerbi.com/view?r=eyJrIjoiMmMwYmM4NDktNjdmMC00NDFkLTkyOWYtNjQ1ODY5MTM2YzA2IiwidCI6IjlkMWNkYTQ5LTQzNDYtNDU3MS1iOTBiLWU2NjM2NjhjODNiYiJ9';
      } else {
        return ''; 
      }
    },
    tab(){
      return `tab-${this.pos}`;
    },
    fsLabel() { return this.isFullscreen ? 'Salir de Pantalla Completa' : 'Pantalla Completa'; },
    fsIcon()  { return this.isFullscreen ? 'mdi-arrow-collapse-all' : 'mdi-arrow-expand-all'; },
  },
  data () {
    return {
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    interval: null,
    pos: 1,
    tiempoActualizacion: 1, //minutos
    isFullscreen: false,
    //powerBIEmbedUrl: 'src=https://app.powerbi.com/view?r=eyJrIjoi…&embed=true'
    }
  },
  methods: {
    close(){
      this.$emit('input', false);
    },

    async extenderPantalla() {
      const ref = this.$refs.fsRoot;
      const el = ref?.$el || ref;
      if (!el) return;

      const isFs = !!(document.fullscreenElement ||
                      document.webkitFullscreenElement ||
                      document.msFullscreenElement);

      try {
        if (!isFs) {
          await this._enterFullscreen(el);
        } else {
          await this._exitFullscreen();
        }
      } finally {
        this.isFullscreen = !!(document.fullscreenElement ||
                              document.webkitFullscreenElement ||
                              document.msFullscreenElement);
      }
    },

    async _enterFullscreen(el) {
      const anyEl = el;
      if (anyEl.requestFullscreen)       return anyEl.requestFullscreen();
      if (anyEl.webkitRequestFullscreen) return anyEl.webkitRequestFullscreen();
      if (anyEl.msRequestFullscreen)     return anyEl.msRequestFullscreen();
      this.$toast && this.$toast.error?.('Pantalla completa no soportada en este navegador');
    },

    async _exitFullscreen() {
      const anyDoc = document;
      if (document.exitFullscreen)       return document.exitFullscreen();
      if (anyDoc.webkitExitFullscreen)   return anyDoc.webkitExitFullscreen();
      if (anyDoc.msExitFullscreen)       return anyDoc.msExitFullscreen();
    },
  }
}
</script>

<style scoped>
/* El card ocupa la pantalla (cuando esté fullscreen o si tu layout ya lo hace, igual funciona) */
.projection{
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* El card-text debe ser flex para repartir topbar + tabs */
.projection__body{
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  /* quita el min-height fijo */
}

/* barra superior no crece */
.projection__topbar{ flex: 0 0 auto; }

/* para pasar “100% alto” al componente hijo */
.fill-parent{
  height: 100%;
  min-height: 0;
}

/* vuetify v-tabs-items -> v-window-item -> content */
.projection__tabs,
.projection__tab-item{
  height: 100%;
  min-height: 0;
}

/* Vue 2 + Vuetify: usa deep para tocar clases internas */
.projection__tab-item >>> .v-window-item__content{
  height: 100%;
  min-height: 0;
}

.fullscreen-mode{
  width: 100vw !important;
  height: 100vh !important;
}
</style>